// Shared GraphQL error classification for the fetch/retry paths in
// useMergeRequests.js and useCommentAttention.js. Kept in one place so both
// hooks apply the same retry policy rather than each maintaining a copy.

// A GraphQL `errors` response with no usable data is only worth retrying when
// the failure looks transient (timeout, rate limit, upstream unavailable).
// Permanent errors — unknown fields, permission denied, validation — will fail
// identically on retry, so retrying just burns the backoff budget.
const TRANSIENT_GRAPHQL_ERROR_PATTERN =
	/\b(timeout|timed out|rate.?limit|throttl|temporarily unavailable|try again|internal server error|service unavailable|502|503|504)\b/i;

export const isRetryableGraphqlErrors = (errors) => {
	if (!Array.isArray(errors) || errors.length === 0) return false;
	return errors.some((err) => {
		const code = err?.extensions?.code || err?.extensions?.classification || "";
		if (/^(TIMEOUT|RATE_LIMITED|INTERNAL|UNAVAILABLE)$/i.test(String(code))) {
			return true;
		}
		return TRANSIENT_GRAPHQL_ERROR_PATTERN.test(err?.message || "");
	});
};
